import { logError } from "../../api/logError";
import type { Section, SectionGroup } from "../types";

export type SectionGroupWithSections = SectionGroup & { sections: Section[] };

export const mapSectionsToSectionGroupsWithSections = (
  sections: Section[],
  sectionGroups: SectionGroup[]
): SectionGroupWithSections[] => {
  const sectionGroupWithSections = new Map<SectionGroup["id"], SectionGroupWithSections>();

  sectionGroups.forEach(group =>
    sectionGroupWithSections.set(group.id, { name: group.name, id: group.id, sections: [] })
  );

  sections.forEach(section => {
    if (!section.sectionGroupId) return logError(`"sectionGroupId" is required when form has sectionGroups`);

    const group = sectionGroupWithSections.get(section.sectionGroupId);
    if (group) group.sections.push(section);
    else logError(`Section "${section.name}" does not match any group.`);
  });

  return Array.from(sectionGroupWithSections.values());
};
